var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-button',_vm._b({class:("button-group-button px-0 " + (_vm.isActive ? '--active' : '')),attrs:{"ghost":!_vm.isActive,"small":""},on:{"click":function () { return _vm.$emit('click'); }}},'v-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }